// Friendly labels for workflow/change-request kinds. The backend enum is
// terse / snake_case ("cr_update", "other"…) — render these instead so the
// Approvals page reads as English, not a database dump.
export const KIND_LABELS = {
  cr_update: 'Commercial Registration',
  baladiya_update: 'Baladiya / Municipality',
  tax_card_update: 'Tax Card',
  shareholder_change: 'Shareholder Change',
  legal_doc_update: 'Legal Document',
  financial_submission: 'Financial Submission',
  agreement_update: 'Agreement',
  entity_closure: 'Entity Closure',
  content_publish: 'Content Publish',
  other: 'General',
};

export function kindLabel(k) {
  if (!k) return 'General';
  return KIND_LABELS[k] || k.replace(/_/g, ' ');
}
